// alterado - revisado

import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    SvgIconPatrimonioImobilizado,
    SvgIconReceitaMensal,
    SvgIconRecursosFinanceiros,
    SvgIconSeguroVida,
} from '../../../business-components/SvgIcon/SvgIconGarantiasAtuais/SvgIconGarantiasAtuais'

import {
    SvgIconTotal,
} from '../../../business-components/SvgIcon/SvgIconEstudo/SvgIconEstudo'

import EstudoFormPanel from './EstudoFormPanel'

import EstudoFormGarantiasPatrimonioImobilizado from '../estudo-form/EstudoFormGarantiasPatrimonioImobilizado'

import EstudoFormGarantiasReceitaMensal from '../estudo-form/EstudoFormGarantiasReceitaMensal'

import EstudoFormGarantiasRecursosFinanceiros from '../estudo-form/EstudoFormGarantiasRecursosFinanceiros'

import EstudoFormSeguroVida from '../estudo-form/EstudoFormSeguroVida'

import EstudoFormGroupPanel from './EstudoFormGroupPanel'



const EstudoFormGarantiasPanelRadioGroup = ({ values, estudo }) => {
    
    const painelList =
        [
            {
                id: 1,
                descricao: estudo.current.panelGarantiasAtuais[HARDCODE.indexEstudoPatrimonioImobilizado].descricao,
                svgIcon: SvgIconPatrimonioImobilizado,
                conteudo:
                    <EstudoFormPanel
                        values={values}
                        panelValores={estudo.current.panelGarantiasAtuais[HARDCODE.indexEstudoPatrimonioImobilizado]}
                        tipoPanel={HARDCODE.tipoPanelGarantiasAtuais}
                    />,
                form: 
                    <EstudoFormGarantiasPatrimonioImobilizado
                        values={values}
                        estudo={estudo}
                    />,
            },
            {
                id: 2,
                descricao: estudo.current.panelGarantiasAtuais[HARDCODE.indexEstudoReceitaMensal].descricao,
                svgIcon: SvgIconReceitaMensal,
                conteudo:
                    <EstudoFormPanel
                        values={values}
                        panelValores={estudo.current.panelGarantiasAtuais[HARDCODE.indexEstudoReceitaMensal]}
                        tipoPanel={HARDCODE.tipoPanelGarantiasAtuais}
                    />,
                form: 
                    <EstudoFormGarantiasReceitaMensal
                        values={values}
                        estudo={estudo}
                    />,
            },
            {
                id: 3,
                descricao: estudo.current.panelGarantiasAtuais[HARDCODE.indexEstudoRecursosFinanceiros].descricao,
                svgIcon: SvgIconRecursosFinanceiros,
                conteudo:
                    <EstudoFormPanel
                        values={values}
                        panelValores={estudo.current.panelGarantiasAtuais[HARDCODE.indexEstudoRecursosFinanceiros]}
                        tipoPanel={HARDCODE.tipoPanelGarantiasAtuais}
                    />,
                form: 
                    <EstudoFormGarantiasRecursosFinanceiros
                        values={values}
                        estudo={estudo}
                    />,
            },
            {
                id: 4,
                descricao: estudo.current.panelGarantiasAtuais[HARDCODE.indexEstudoSeguroVida].descricao,
                svgIcon: SvgIconSeguroVida,
                conteudo:
                    <EstudoFormPanel
                        values={values}
                        panelValores={estudo.current.panelGarantiasAtuais[HARDCODE.indexEstudoSeguroVida]}
                        tipoPanel={HARDCODE.tipoPanelGarantiasAtuais}
                    />,
                form: 
                    <EstudoFormSeguroVida
                        values={values}
                        estudo={estudo}
                    />,
            },
            {
                id: 5,
                descricao: estudo.current.panelGarantiasAtuais[HARDCODE.indexEstudoTotalGarantias].descricao,
                svgIcon: SvgIconTotal,
                conteudo:
                    <EstudoFormPanel
                        values={values}
                        panelValores={estudo.current.panelGarantiasAtuais[HARDCODE.indexEstudoTotalGarantias]}
                        tipoPanel={HARDCODE.tipoPanelGarantiasAtuais}
                    />,
                form:
                    <>
                        <EstudoFormGarantiasPatrimonioImobilizado
                            values={values}
                            estudo={estudo}
                        />
                        <EstudoFormGarantiasReceitaMensal
                            values={values}
                            estudo={estudo}
                        />
                        <EstudoFormGarantiasRecursosFinanceiros
                            values={values}
                            estudo={estudo}
                        />
                        <EstudoFormSeguroVida
                            values={values}
                            estudo={estudo}
                        />
                    </>,
                total: true,
            },
        ]

    return (

        <EstudoFormGroupPanel
            title={LABEL.garantiasAtuais}
            panelList={painelList}
        />
    )
}

export default EstudoFormGarantiasPanelRadioGroup